import router from '@/router';
import { environments } from '../config/configManager';
import { createHttpClient } from './create-http-client';

const client = createHttpClient({
  baseURL: environments.partner,
  getAuthHeaders: () => {
    const accessToken = localStorage.getItem('token');
    return accessToken ? { Authorization: accessToken } : {};
  },
  afterSuccess: () => {},
  afterError: ({ status, isNetwork }) => {
    if (isNetwork) return;
    switch (status) {
      case 403:
        router.replace('/').catch(() => {});
        break;
      default:
        break;
    }
  },
});

export default client;
